import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: first name
 * @returns {ReactElement} textbox prompting for first name
 */
const FirstName = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.FIRST_NAME}
			label='First Name'
			required
		/>
	);
};
export default FirstName;
